import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import EmailStep from "../components/EmailStep";
import BillingStep from "../components/BillingStep";
import PaymentStep from "../components/PaymentStep";
import OrderItems from "../components/OrderItems";
import { CartContext } from "../context/CartContext";
import FormatPrice from "../helper/FormatPrice";
import { AuthContext } from "../context/AuthContext";
import axios from "../helper/axios";

const Checkout = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState(null);

  const [order_id, setOrderId] = useState(1001); // Initial order_id value
  const [totalAmnt, setTotalAmnt] = useState(0);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
  const [isBillingSubmitted, setIsBillingSubmitted] = useState(false);

  const [shippingData, setShippingData] = useState({ shippingAddress1: " " });
  const [billingData, setBillingData] = useState({});

  const [orderData, setOrderData] = useState("");

  const {
    cartItems,
    addToCart,
    removeFromCart,
    clearCart,
    removeProduct,
    temporaryCartItems,
  } = useContext(CartContext);

  const [paymentData, setPaymentData] = useState({
    // paymentMethod: "",
    // product_id_fk: "22",
    // user_id_fk: "17",
    // shipping_date: "",
    // per_unit_price: 200,
    // order_notes: 10,
    // other_charges_1: 10,
    // other_charges_2: 10,
    // other_charges_3: 10,
    // tax_1: 10,
    // tax_2: 10,
    // tax_3: 10,
    // tax_4: 10,
    // country_code: 91,
    // disc_amt: 10,
    // disc_pr: 10,
    // status: 1,
    // total_qty: 10,
    // total_price: 1000,
  });

  // console.log("̥paymentData", paymentData);

  const token = localStorage.getItem("token");
  const emailId = localStorage.getItem("emailId");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    calculateTotalAmount();
    // handleFormSubmit();
  }, [cartItems]);

  const handleEmailSubmit = (email) => {
    setEmail(email);
    setIsEmailSubmitted(true); // Set email submission status to true
    setStep(2);
  };

  const handleBillingSubmit = (billingData, shippingData) => {
    setBillingData(billingData);
    setShippingData(shippingData);
    setIsBillingSubmitted(true); // Set billing submission status to true
    setStep(3);
  };

  const handlePaymentSubmit = async (data, e) => {
    try {
      const response = await axios.post(
        "/checkout_insert",
        data,
        // JSON.stringify(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Data Inserted Into Checkout");

      // Redirect to the order-placed page with the data in state
      navigate("/order-placed", {
        state: {
          email,
          shippingData,
          billingData,
          paymentData: response.data.data,
          cartItems,
          totalAmnt,
        },
      });

      // console.log('JSON.stringify(cartItems.product_id)̥', JSON.stringify(cartItems.product_id)̥);

      // const test = cartItems.map((item) => {
      //   JSON.stringify(item.product_id);
      //   console.log('̥JSON.stringify(item.product_id)', JSON.stringify(item.product_id));
      //   item.product_id;
      // });

      // console.log("cartItems.product_id", cartItems[0].product_id);

      const order_details = {
        order_id: order_id,
        user_id_fk: userId,
        product_id_fk: cartItems[0].product_id,
        is_in_cart: 1,
        order_status: 1,
        payment_methods: 1,
      };

      // Increment the order_id by 1 after each function call
      const incrementOrderId = () => {
        setOrderId(order_id + 1);
      };
      incrementOrderId();

      const response1 = await axios.post(
        "/order_insert",
        order_details,
        // JSON.stringify(order_details),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("̥response1", response1);
    } catch (error) {
      console.error("API Error:", error);
      alert("An error occurred while processing the payment.");
    }
  };

  const handleEditStep = (stepNumber) => {
    setStep(stepNumber);
  };

  const calculateTotalAmount = () => {
    let total = 0;
    cartItems.forEach((item) => {
      total += item.price * item.qty;
    });
    setTotalAmnt(total);
  };

  const isStepDataSubmitted = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        return isEmailSubmitted;
      case 2:
        return isBillingSubmitted;
      default:
        return false;
    }
  };

  const renderCurrentStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <h4>Contact Information</h4>
            <div className="email">
              {email && `Your Entered Email is ${email}`}
              <EmailStep onSubmit={handleEmailSubmit} />
            </div>
            <hr />
          </>
        );

      case 2:
        return (
          <>
            <h4>Billing Information</h4>

            <div className="billing">
              {<BillingStep onSubmit={handleBillingSubmit} />}
            </div>
            <hr />
          </>
        );

      case 3:
        return (
          <>
            <h5>Payment Method</h5>
            <div className="payment">
              {
                <PaymentStep
                  handlePaymentSubmit={handlePaymentSubmit}
                  paymentData={paymentData}
                  setPaymentData={setPaymentData}
                />
              }
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <h1 className="my-5 fw-bold">Secure Checkout</h1>
          <div className="col-8 f-flex">
            {renderCurrentStep()}

            {step > 1 && (
              <button
                className="link-style me-3"
                onClick={() => handleEditStep(step - 1)}
              >
                Edit Previous Step
              </button>
            )}
            {step < 3 && (
              <button
                className="link-style"
                onClick={() => handleEditStep(step + 1)}
                disabled={!isStepDataSubmitted(step)}
              >
                Edit Next Step
              </button>
            )}
          </div>

          <div className="col-4 border rounded border-secondary py-4">
            <h5 className="mb-4 text-center fw-bold">Order Summery</h5>
            <div
              className="row d-flex justify-content-around"
              style={{ height: "auto", overflow: "auto" }}
            >
              {!cartItems || (!temporaryCartItems && <p>No Orders</p>)}
              {temporaryCartItems &&
                !token &&
                temporaryCartItems.map((curElem, index) => {
                  return <OrderItems key={index} {...curElem} />;
                })}
              {cartItems &&
                token &&
                cartItems.map((curElem, index) => {
                  return <OrderItems key={index} {...curElem} />;
                })}
            </div>

            <table className="table my-3">
              <tbody>
                <tr>
                  <td className="text-start">Merchandise Subtotal:</td>
                  <td className="text-end">
                    <FormatPrice price={totalAmnt} />
                  </td>
                </tr>
                <tr>
                  <td className="text-start fw-bold">Order Total:</td>
                  <td className="text-end fw-bold">
                    <FormatPrice price={totalAmnt} />
                  </td>
                </tr>
              </tbody>
            </table>
            <br />

            <p className="text-center">
              <a href="#" className="fw-bold link-dark">
                Need Assistance?
              </a>
            </p>
            <div className="contact mt-5 d-flex justify-content-evenly align-items-center">
              <a href="#" className="link-dark">
                <i className="fa-solid fa-phone-volume"></i> 1234567890
              </a>
              <a href="#" className="link-dark">
                <i className="fa-solid fa-comments"></i> Live Chat
              </a>
              <a href="#" className="link-dark">
                <i className="fa-solid fa-envelope"></i> Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
